// extracted by mini-css-extract-plugin
export default {"pill":"SubscriptionsTag_pill__CjgXg","pillActive":"SubscriptionsTag_pillActive__ZSuJ8"};